import React, { FC, MouseEvent } from 'react';
import { Hyperlink } from '../../../components/Hyperlink';
import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import styles from './public_signup_banner.module.scss';

type Props = {
  button_text: string;
  subtitle: string;
  title: string;
  pageName: string;
  landing?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export const PublicSignupBanner: FC<Props> = ({
  button_text,
  subtitle,
  title,
  pageName,
  landing,
  onClick = () => {},
}) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <div
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <p className={styles.subTitle}>{subtitle}</p>
      <Hyperlink
        className={styles.link}
        href={buildUrlWithParameters('/inscription', {
          sourcePage: pageName,
          ...(landing && {
            landing,
          }),
        })}
        onClick={onClick}
      >
        <span className={styles.linkText}>{button_text}</span>
        <span className={styles.icon}>
          <MaterialIcon name="arrow_forward" />
        </span>
      </Hyperlink>
    </div>
  </div>
);
